import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository"
// import Nat from "natjs/lib";
import env from "@/utils/env";
import authenticationInterceptor from "@/components/core/authentication/AuthenticationInterceptor";

const resource = "/document";
export default {
  uploadDocument(
    entityType, entityId, name,
    description, subDirectory, file,
    imageType, uploadToMifos
  ) {
    return new Promise((resolve, reject) => {
      if (env.isWebPlatform()) {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('name', name);
        formData.append('description', description);
        formData.append('subDirectory', subDirectory);
        formData.append('entityType', entityType);
        formData.append('entityId', entityId);
        formData.append('uploadToMifos', uploadToMifos);
        formData.append('imageType', imageType);

        creditEngineRepository.setContentType("multipart/form-data");
        CreditEngineRepository.post(`${resource}/uploadDocument`, formData)
          .then(res => {
            resolve(res)
          }).catch(err => {
          reject(err)
        })
      } else {
/*
        Nat.upload(serverUrl + `${resource}/uploadDocument`, {
          path: file,
          method: 'POST',
          formData: {
            'name': name,
            'description': description,
            'subDirectory': subDirectory,
            'entityType': entityType,
            'entityId': entityId,
            'uploadToMifos': uploadToMifos,
            'imageType': imageType
          },
          headers: {
            // Content-Type is not required in Nat lib
            'Fineract-Platform-TenantId': fineractPlatformTenantId,
            'Authorization': authenticationInterceptor.getAuthorizationHeader()
          }
        }, (err, ret) => {
          if (err) {
            reject(err)
          } else if (ret) {
            resolve(ret)
          }
        })
*/
      }
    })
  },

  checkPdfPassword(pdfPasswordRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/pdf/checkPassword`, pdfPasswordRequest)
  }
}
